module.exports = __webpack_public_path__ + "img/5.c0e75894.webp";